import { MoneyObject } from '../types/dataMatched'
/**
 * 从URL参数中获取参数值
 */
export const getParamFromUrl = (paramName: string): string | null => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(paramName);
};

export function thousandBitSeparator(num?: number | string) {
  if (!num) return ''
  if (num && num.toString().indexOf(',') > -1) {
    return num
  }
  const re = /(-?\d+)(\d{3})/g
  while (re.test(num.toString())) {
    num = num.toString().replace(re, '$1,$2')
  }
  return num.toString()
}

export function getAmountText(amount: MoneyObject) {
  return `${amount?.standardSymbol || ''}${amount?.standard || 0}`
}

// 将金额格式化为 CNY，无法解析时保留原值
export const formatAmount = (amount?: MoneyObject | string | number) => {
  if (amount === undefined || amount === null) return '';
  const raw = typeof amount === 'object' && amount !== null ? (amount as MoneyObject).standard : amount;
  const num = Number(raw);
  if (Number.isFinite(num)) return `CNY ${num.toFixed(2)}`;
  return typeof raw === 'string' ? `CNY ${raw}` : 'CNY 0.00';
};

// Message update utilities
interface ToolInvocation {
  state: string;
  step: number;
  toolCallId: string;
  toolName: string;
  result: any;
}

interface MessagePart {
  type: string;
  text?: string;
  toolInvocation?: ToolInvocation;
}

export interface MsgBody {
  id: string;
  createdAt: string;
  role: string;
  content: string;
  parts: MessagePart[];
  revisionId: string;
}

/**
 * 更新消息体中指定 toolCallId 的 result 数据
 * @param msgBody 原始消息体
 * @param toolCallId 要更新的 toolCallId
 * @param newResult 新的 result 数据
 * @returns 更新后的消息体（不可变更新）
 */
export function updateMsg(msgBody: MsgBody, toolCallId: string, newResult: any): MsgBody {
  return {
    ...msgBody,
    parts: msgBody.parts.map(part => {
      if (part.type === 'tool-invocation' && part.toolInvocation?.toolCallId === toolCallId) {
        return {
          ...part,
          toolInvocation: {
            ...part.toolInvocation,
            result: newResult
          }
        };
      }
      return part;
    })
  };
}